import { TravelAnalytics } from "@shared/interfaces/travel-analytics.interface";

/**
 * Parse a raw tracker coordinate string into a finite number.
 * Returns null when the value is missing or not a valid number, e.g. the "S/N"
 * placeholder a truncated/corrupted tracker packet emits for every field.
 * @param value raw coordinate string coming from the normalized tracker content
 */
export const parseCoordinate = (value?: string | null): number | null => {
  if (value === null || value === undefined || value === "") return null;

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Whether a travel analytic record carries usable numeric GPS coordinates.
 * Corrupted records (LAT/LON = "S/N") must be skipped before building map
 * markers/polylines, otherwise `new LatLng(NaN, NaN)` throws "lat or lng are
 * not numbers" and the whole travel view crashes.
 * @param record travel analytic record returned by get-travel-analytics
 */
export const hasValidCoordinates = (record: TravelAnalytics): boolean =>
  parseCoordinate(record?.content?.LAT?.content) !== null
  && parseCoordinate(record?.content?.LON?.content) !== null;
